import type { AppConfig } from './types'
import { validateConfig } from './types'

let cfg: AppConfig | null = null

export async function loadConfig(): Promise<AppConfig> {
  if (cfg) return cfg
  const raw = (window as any).__APP_CONFIG__
  cfg = Object.freeze(validateConfig(raw))
  return cfg
}

export function getConfig(): AppConfig {
  if (!cfg) {
    throw new Error('💥 Config not loaded yet. Call loadConfig() first or use getDevelopmentConfig() for development.')
  }
  return cfg
}
